import React from 'react';
import { useField } from 'formik';
import { Checkbox, ListItemButton, ListItemIcon, Typography } from '@mui/material';


import { withStyles } from 'tss-react/mui';


const SmallCheckbox = withStyles(Checkbox, {
  root: {
    padding: '4px'
  }
});


export type CheckboxListItemProps = {
  name: string;
  label: string;
  setValue: (v: boolean) => void;
  checked?: boolean;
  disabled?: boolean;
};


export const CheckboxListItem: React.FC<CheckboxListItemProps> = ({ label, checked, disabled, setValue }) => {
  return (
    <ListItemButton dense disabled={disabled} onClick={() => setValue(!checked)}>
      <ListItemIcon style={{ minWidth: 0, marginRight: 12 }}>
        <SmallCheckbox size="small" disableRipple tabIndex={-1} checked={checked ?? false} disabled={disabled} />
      </ListItemIcon>
      <Typography component="span" color="textPrimary" variant="body1" style={{ fontWeight: 400 }}>{label}</Typography>
    </ListItemButton>
  );
};

export const CheckboxListItemField: React.FC<Omit<CheckboxListItemProps, 'checked' | 'setValue'>> = (props) => {
  const [ field, _meta, helpers ] = useField({
    name: props.name,
    type: 'checkbox',
  });

  return <CheckboxListItem {...props} checked={field.checked} setValue={helpers.setValue} />;

};
